<img src="assets/img/loading.gif">
